import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "components/yenimahalle/Layout";
import ContentHeader from "components/yenimahalle/ContentHeader";
import ContentText from "components/yenimahalle/ContentText";
import AlbumImages from "components/yenimahalle/AlbumImages";
import PortalApi from "../../api/PortalApi";
import { GetNewsDetailResponse, NewsList, OtherNewsList } from "../../models/Response/Portal";
import tw from "twin.macro";
import { dateFormatter } from "utils/dateFormatter";
import { slugify } from "utils/slugify";
import RoutingSidebar from "components/yenimahalle/RoutingSidebar";
import BasicHeader from "components/yenimahalle/BasicHeader";
import styled from "styled-components";

interface NewsItem {
  id: number;
  title: string;
  date: string;
  description?: string;
  imageSrc?: string;
}
// Styled Components
const NewsContentContainer = tw.div`
  pt-8 pb-16 px-4
  flex flex-col lg:flex-row
  justify-between items-start
  max-w-screen-xl mx-auto
`;

const LeftColumn = tw.div`w-full lg:w-9/12 px-5`;
const RightColumn = tw.div`w-full lg:w-3/12 mt-8 lg:mt-0`;

const Card = styled.a`
  ${tw`
    flex flex-col h-full w-full 
    sm:border sm:rounded-tl-4xl sm:rounded-br-5xl 
    relative focus:outline-none
    bg-primary-200 text-black
    cursor-default
  `}
`;


interface CardImageProps {
  imageSrc: string;
}
const CardImage = styled.img`
  ${tw`
    w-full 
    rounded-tl-4xl 
    sm:rounded-none 
    sm:rounded-tl-4xl 
    rounded-br-4xl 
    object-cover 
    mx-auto 
    block
  `}
  height: auto;
  max-height: 400px;
`;

const Heading = tw.span`
  inline-block my-4 pl-3 py-1 text-xl font-bold border-l-4 border-primary-500
`;

const HaberDetaylari: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [haber, setHaber] = useState<GetNewsDetailResponse | null>(null);
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
  const navigate = useNavigate();

  const fetchNew = async () => {
    const response = await PortalApi.getNewsDetail(Number(id));
    if (response) {
      setHaber(response.content);
    }
  };
  const months = [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ];

  useEffect(() => {
    if (id) {
      fetchNew();
    }
  }, [id]);

  const fetchNews = async (month: string, year: string) => {
    const monthIndex = months.indexOf(month);
    const response = await PortalApi.getNewsByDate(
      parseInt(year),
      monthIndex + 1
    );
    if (response && response.content.newsList) {
      const mappedItems = response.content.newsList.map((item: NewsList) => ({
        id: item.newsId,
        title: item.title,
        date: dateFormatter(item.newsDate, false),
        imageSrc: item.mainImageUrl,
      }));
      setNewsItems(mappedItems.slice(0, 5));
    }
  };
  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = months[currentDate.getMonth()]; // getMonth returns 0-based index
    const currentYear = currentDate.getFullYear().toString();
    fetchNews(currentMonth, currentYear);
  }, []);

  const handleCardClick = (item: NewsItem & { id: number }) => {
    const url = `/HaberDetay/${slugify(item.title)}/${item.id}`;
    navigate(url);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!haber) {
    return <div>Yükleniyor...</div>;
  }

  return (
    <Layout>
      <BasicHeader
        headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
        headingLine2=""
      />

      <NewsContentContainer>

        <LeftColumn>
          <Heading>{haber.title}</Heading>
          <Card href={"#"}>
            <CardImage src={haber.mainImageUrl} />
          </Card>
          <ContentText htmlContent={haber.content} />


          {haber.photoGaleryUrlList.length > 0 && (
            <>
              <Heading>Foto Galeri</Heading>
              <AlbumImages images={haber.photoGaleryUrlList} />
            </>
          )}
        </LeftColumn>

        <RightColumn>
          <RoutingSidebar
            heading="Diğer Haberler"
            cards={haber.otherNewsList.map((item: OtherNewsList) => ({
              id: item.newsId,
              title: item.title,
              imageSrc: item.mainImageUrl,
            }))}
            onItemClick={handleCardClick}

          />
        </RightColumn>
      </NewsContentContainer>
    </Layout>
  );
};

export default HaberDetaylari;
